export const tokensModule = {
    slug: 'tokens',
    label: 'Tokens',
    description: 'API tokens for the public /api/v1 endpoint.',
    icon: 'Key',
};
//# sourceMappingURL=tokens.js.map